export * from "./slider_list";
